export default __webpack_public_path__ + "static/media/noimageavailable_cropped.56460d27.png";